import Stack from "@mui/material/Stack";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { NavItem } from "../../../components/primitives/navigation/NavItem";
import { ROUTES } from "../../../route_paths";

const SIDEBAR_WIDTH = 196;

/** Persistent left nav for the expert-insights section. Hidden on mobile (top NavBar covers it). */
export function ExpertInsightsNav() {
  return (
    <Stack
      component="nav"
      sx={{
        display: { xs: "none", md: "flex" },
        width: SIDEBAR_WIDTH,
        flexShrink: 0,
        borderRight: "1px solid",
        borderColor: "divider",
        p: 1,
        gap: 0.5,
      }}
    >
      <NavItem
        to={ROUTES.expertInsights.insights.path()}
        label="Insights"
        icon={<ArticleOutlinedIcon />}
      />
    </Stack>
  );
}
